import { type EntriesQueryScope, useEntriesCache } from "@/shared/cache";
import type { Entry } from "./normalize";

/**
 * Thin adapter around the entries cache so the view keeps its existing
 * `{ data, isLoading }` contract. The cache returns canonical `Entry[]`.
 */
export function useAllEntries(
	scope?: EntriesQueryScope,
	options: { enabled?: boolean } = {},
): { data: Entry[]; isLoading: boolean } {
	const { entries, isLoading } = useEntriesCache(scope, options);
	return { data: entries, isLoading };
}
